<template>
  <v-dialog v-model="dialog" max-width="960">
    <template #activator="{on}">
        <slot name="activator" :on="on">
            <v-btn icon v-on="on">
                <v-icon><mdi-wrench></mdi-wrench></v-icon>
            </v-btn>
        </slot>
    </template>
    <v-card :disabled="loading" :loading="loading">
        <v-card-title>Mark a product as not built</v-card-title>
        <v-card-text>
            <v-text-field
                v-model="quantity"
                :label="'Number of product (' + item.product.name + ') you want mark as not built'"
                :hint="'Maximum: ' + maximumItemCanBeMarked "
                type="number"
                :max="maximumItemCanBeMarked"
            />
        </v-card-text>
        <v-card-actions>
            <v-btn @click="dialog=false">
                Cancel
            </v-btn>
            <v-spacer />
            <v-btn @click="doMarkAsBuilt" color="orange" dark>
                Mark as built
            </v-btn>
        </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
    name: 'HandlingDialogMarkProductAsNotBuilt',
    props: {
        item: {
            type:Object,
            required: true
        }
    },
    data: () => ({
        dialog: false,
        quantity: null
    }),
    computed : {
        ...mapGetters('handling', ['loading']),
        maximumItemCanBeMarked () {
            return this.item.built
        }
    },
    methods: {
        ...mapActions('handling', { markProductAsNotBuilt : 'markProductAsNotBuilt'}),
        doClose(){
            this.dialog=false
            this.quantity=null
        },
        doMarkAsBuilt () {
            if(this.quantity && this.quantity <= this.maximumItemCanBeMarked) {
                this.markProductAsNotBuilt({
                    id: this.item.id,
                    quantityToMarkAsNotBuilt : this.quantity
                }).then(() => {
                    this.doClose()
                    this.$emit('update');
                })
            }
        }
    }
}
</script>

<style>

</style>